import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1339_52621)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M49.1383 41.3797H0.862596C0.386523 41.3797 0.000488281 40.9937 0.000488281 40.5176V9.4832C0.000488281 9.00713 0.386523 8.62109 0.862596 8.62109H49.1384C49.6145 8.62109 50.0005 9.00713 50.0005 9.4832V40.5176C50.0004 40.9938 49.6144 41.3797 49.1383 41.3797Z",
				fill: "#CD343C"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M34.4835 21.5518H28.449V15.5174C28.449 15.0413 28.063 14.6553 27.5869 14.6553H22.4144C21.9384 14.6553 21.5523 15.0413 21.5523 15.5174V21.5518H15.5179C15.0418 21.5518 14.6558 21.9379 14.6558 22.4139V27.5864C14.6558 28.0625 15.0418 28.4485 15.5179 28.4485H21.5523V34.483C21.5523 34.959 21.9384 35.3451 22.4144 35.3451H27.5869C28.063 35.3451 28.449 34.959 28.449 34.483V28.4483H34.4835C34.9595 28.4483 35.3456 28.0623 35.3456 27.5862V22.4138C35.3456 21.9378 34.9595 21.5518 34.4835 21.5518Z",
				fill: "#F3F3F3"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1339_52621",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 50,
				height: 50,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgChFlag);
export { ForwardRef as ReactComponent };
